import { usePlaybackPlay } from '@app/core/playback/hooks/usePlayback';
import { AuditLiveMention } from '@app/modules/audit/modules/station-audit/types';
import { toTimestamp } from '@mi-front/core';
import { Button } from '@mui/material';
import { useIntl } from 'react-intl';

/**
 * Plays the stream from the mention's timestamp.
 */
export function MentionPlayBtn(p: { liveMention: AuditLiveMention }) {
  const { $t } = useIntl();
  const play = usePlaybackPlay();

  const handlePlay = () => {
    play({
      startTs: toTimestamp(p.liveMention.datetime),
    });
  };

  return (
    <Button size="small" sx={{ marginTop: 0.5 }} onClick={handlePlay}>
      {$t({
        id: 'common.play',
        defaultMessage: 'Reproducir',
      })}
    </Button>
  );
}
